document.addEventListener('click', async (event) => {
  const button = event.target.closest('[data-whatsapp-order]');

  if (!button) return;

  event.preventDefault();

  button.disabled = true;

  const originalText = button.textContent;
  button.textContent = '正在整理訂單...';

  try {
    const response = await fetch(
      `${window.Shopify.routes.root}cart.js`,
      {
        headers: {
          Accept: 'application/json'
        }
      }
    );

    if (!response.ok) {
      throw new Error('Unable to load cart');
    }

    const cart = await response.json();

    if (!cart.items || cart.items.length === 0) {
      alert('購物車暫時沒有商品');
      return;
    }

    let message = '';

    message += '【泰星匯泰國菜｜到會預訂】\n\n';

    message += '餐點：\n';

    cart.items.forEach((item, index) => {
      message += `${index + 1}. ${item.product_title}`;

      if (
        item.variant_title &&
        item.variant_title !== 'Default Title'
      ) {
        message += `｜${item.variant_title}`;
      }

      message += ` × ${item.quantity}`;

      const itemTotal = item.final_line_price / 100;

      message += `｜HK$${itemTotal.toFixed(2)}\n`;

      // Line item properties
      if (item.properties) {
        Object.entries(item.properties).forEach(([key, value]) => {
          if (
            value &&
            !key.startsWith('_')
          ) {
            message += `   ${key}：${value}\n`;
          }
        });
      }
    });

    const total = cart.total_price / 100;

    message += '\n';
    message += `合計：HK$${total.toFixed(2)}\n`;

    if (total >= 1500) {
      message += '送貨優惠：滿 $1500 免運費\n';
    }

    message += '\n';
    message += '送貨日期：\n';
    message += '送貨時間：\n';
    message += '送貨地址：\n';
    message += '聯絡人：\n';
    message += '聯絡電話：\n';

const whatsappNumber = '85263033968';
const encodedMessage = encodeURIComponent(message);

const isMobile =
  /Android|iPhone|iPad|iPod/i.test(navigator.userAgent);

let whatsappUrl;

if (isMobile) {
  whatsappUrl =
    `whatsapp://send?phone=${whatsappNumber}&text=${encodedMessage}`;
} else {
  whatsappUrl =
    `https://web.whatsapp.com/send?phone=${whatsappNumber}&text=${encodedMessage}`;
}

window.location.href = whatsappUrl;

  } catch (error) {
    console.error(error);

    alert('未能讀取購物車，請稍後再試');
  } finally {
    button.disabled = false;
    button.textContent = originalText;
  }
});